/**
 * @generated SignedSource<<4d166819c2829b7fbf90f6bb86e972e1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotoSwiperWrapper_photoNode$data = {
  readonly photo: {
    readonly height: number | null;
    readonly name: string | null;
    readonly path: string | null;
    readonly serviceId: string | null;
    readonly url: string | null;
    readonly width: number | null;
  } | null;
  readonly " $fragmentType": "PhotoSwiperWrapper_photoNode";
};
export type PhotoSwiperWrapper_photoNode$key = {
  readonly " $data"?: PhotoSwiperWrapper_photoNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotoSwiperWrapper_photoNode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotoSwiperWrapper_photoNode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TradePhoto",
      "kind": "LinkedField",
      "name": "photo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "height",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "width",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradePhotosQueryOutput",
  "abstractKey": null
};

(node as any).hash = "262b9da60c53d5262fe4cfec6b732e8c";

export default node;
